function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
/**
 * n$2 (selectElement)
 * 
 * ### **Selects the first element that matches the specified selector.**
 * @param {string} selector - The CSS selector.
 * @param {HTMLElement} [context=document] - The context element to search within (alternative name: context).
 * @return {HTMLElement|null} - The first matching element or null if not found.
 */
function selectElement(selector, context) {
  return void 0 === context ? document.querySelector(selector) : context.querySelector(selector);
}
/**
 * t$2 (selectElements)
 * 
 * ### **Selects all elements that match the specified selector.**
 * @param {string} selector - The CSS selector.
 * @param {HTMLElement} [context=document] - The context element to search within (alternative name: context).
 * @return {Array} - An array of matching elements.
 */
function selectElements(selector, context) {
  return void 0 === context ? [].slice.call(document.querySelectorAll(selector)) : [].slice.call(context.querySelectorAll(selector));
}

function CloseAccordions (e) {
  let containers = selectElements("[data-type=\"collapsible-content\"]")
  containers.forEach((container)=>{
    let details = container.querySelectorAll('[id^="Details-"]')
    const active = Array.from(details).find(d => d.open)
    details.forEach((detail) => {
        if (!e.currentTarget.closest('details').open && active) {   
                active.open = false
              }
    })
  })
 
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }
    

  summary.addEventListener('click', (event) => {
    CloseAccordions(event)
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      this._checkIfFacets(isOpen)

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  // is facests?! bug facets goes under header menu
  _checkIfFacets(isOpen){
    // not facets RETURN
    if(!this.classList.contains("mobile-facets__wrapper")) return;

    //open ?
    if(!isOpen){
      // go to top and get in front of everything
      window.scrollTo({top: 0, behavior: "smooth"})
      this.mainDetailsToggle.closest(".facets-wrapper").style.zIndex = "50"
    }else{
      // closing?
      // wait some time and get to your position
      setTimeout(()=>{
        this.mainDetailsToggle.closest(".facets-wrapper").style.zIndex = "1"
      }, 400)
    }

  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
    document.body.classList.remove(`overflow-hidden`);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = true;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    // Suppress updates while we are performing a silent reposition to avoid transient UI flicker
    if (this.suppressUpdateUntilReposition || this.isRepositioning) return;

    const previousPage = this.currentPage;
    // Use center-based index detection (more robust for variable widths)
    const detectedIndex = Number.isFinite(this.getIndexFromScroll(this.slider.scrollLeft))
      ? this.getIndexFromScroll(this.slider.scrollLeft)
      : Math.round(this.slider.scrollLeft / this.sliderItemOffset);
    this.currentPage = detectedIndex + 1;

    // For infinite scroll in SlideshowComponent, adjust the displayed page count
    let displayCurrentPage = this.currentPage;
    let displayTotalPages = this.totalPages;
    
    if (this.enableInfiniteScroll && this.infiniteScrollInitialized && this.originalSlides) {
      displayTotalPages = this.originalSlides.length;
      displayCurrentPage = this.currentPage - this.slidesToClone;
      if (displayCurrentPage <= 0) {
        displayCurrentPage += this.originalSlides.length;
      } else if (displayCurrentPage > this.originalSlides.length) {
        displayCurrentPage -= this.originalSlides.length;
      }
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = displayCurrentPage;
      this.pageTotalElement.textContent = displayTotalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }
    
    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  // Return the slide index (in this.sliderItemsToShow) whose center is nearest to the viewport center
  getIndexFromScroll(scrollLeft) {
    if (!this.sliderItemsToShow || !this.sliderItemsToShow.length) return NaN;
    const viewportCenter = scrollLeft + this.slider.clientWidth / 2;
    let bestIndex = 0;
    let bestDist = Infinity;
    this.sliderItemsToShow.forEach((el, i) => {
      const center = el.offsetLeft + el.clientWidth / 2;
      const d = Math.abs(center - viewportCenter);
      if (d < bestDist) {
        bestDist = d;
        bestIndex = i;
      }
    });
    return bestIndex;
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();

    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;

    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();

    this.sliderControlWrapper = this.querySelector('.slider-buttons');

    if (this.sliderControlWrapper) {
      this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
      if (this.sliderItemsToShow && this.sliderItemsToShow.length > 0) this.currentPage = 1;
      this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
      this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;
      this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
      this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
      this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    }

    // Enable infinite scroll for product media galleries (or if explicitly enabled)
    this.enableInfiniteScroll = this.dataset.enableInfiniteSlide === 'true';
  
    // Flags for silent reposition and state
    this.infiniteScrollInitialized = false;
    this.isRepositioning = false;
    this.suppressUpdateUntilReposition = false;
    // Kick off initialization with retries to wait for measurements
    this.tryInitInfiniteScroll();

    [this.prevButton, this.nextButton].forEach((button) => {
      if (!button) return;
      button.addEventListener(
        'click',
        () => {
          this.announcementBarArrowButtonWasClicked = true;
        },
        { once: true }
      );
    });

    if (this.slider && this.slider.getAttribute && this.slider.getAttribute('data-autoplay') === 'true') {
      this.setAutoPlay();
    }
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    
    if (this.enableInfiniteScroll && this.closest('media-gallery')) {
      const step = parseInt(event.currentTarget.dataset.step || 1, 10);
      const slideWidth = this.sliderItemOffset;

      // Safety: if we don't have a valid slideWidth, fall back to original behavior
      if (!slideWidth || !isFinite(slideWidth) || slideWidth === 0) {
        super.onButtonClick(event);
        this.wasClicked = true;
        this.applyAnimationToAnnouncementBar(event.currentTarget.name);
        return;
      }

      // If infinite scroll has been initialized, step by slide index so we land exactly on cloned slides
      if (this.infiniteScrollInitialized && this.sliderItemsToShow && this.sliderItemsToShow.length) {
        const total = this.sliderItemsToShow.length;
        // center-based index detection
        const currentIndex = this.getIndexFromScroll(this.slider.scrollLeft);

        // Debug: optional runtime info if enabled on the element
        const debug = this.getAttribute('data-debug-infinite') === 'true';
        if (debug) console.debug('onButtonClick', { currentIndex, slideWidth, slidesToClone: this.slidesToClone, originalSlides: this.originalSlides ? this.originalSlides.length : 0 });

        if (!Number.isFinite(currentIndex)) {
          // Fallback to pixel movement
          const direction = event.currentTarget.name === 'next' ? 1 : -1;
          const currentScroll = this.slider.scrollLeft;
          const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
          let newPosition = currentScroll + (direction * step * slideWidth);
          if (direction === 1 && newPosition > maxScroll) newPosition = 0;
          else if (direction === -1 && newPosition < 0) newPosition = maxScroll;
          this.slider.scrollTo({ left: newPosition, behavior: 'smooth' });
        } else {
          const direction = event.currentTarget.name === 'next' ? 1 : -1;
          const realCount = this.originalSlides ? this.originalSlides.length : 0;

          // Edge-case: animate into cloned slides so reposition corrects to real slide
          if (realCount > 0 && direction === -1 && currentIndex === this.slidesToClone) {
            const targetIndex = this.slidesToClone - 1; // last prepended clone
            const newPosition = this.sliderItemsToShow[targetIndex].offsetLeft;
            this.suppressUpdateUntilReposition = true;
            this.slider.scrollTo({ left: newPosition, behavior: 'smooth' });
          }
          else if (realCount > 0 && direction === 1 && currentIndex === this.slidesToClone + realCount - 1) {
            const targetIndex = this.slidesToClone + realCount; // first appended clone
            const newPosition = this.sliderItemsToShow[targetIndex].offsetLeft;
            this.suppressUpdateUntilReposition = true;
            this.slider.scrollTo({ left: newPosition, behavior: 'smooth' });
          }
          else {
            let targetIndex = currentIndex + direction * step;

            // Clamp into valid range
            if (targetIndex < 0) targetIndex = 0;
            if (targetIndex > total - 1) targetIndex = total - 1;

            const newPosition = this.sliderItemsToShow[targetIndex].offsetLeft;
            this.slider.scrollTo({ left: newPosition, behavior: 'smooth' });
          }
        }
      } else {
        // Fallback: basic pixel-based scroll if not yet initialized
        const direction = event.currentTarget.name === 'next' ? 1 : -1;
        const currentScroll = this.slider.scrollLeft;
        const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
        let newPosition = currentScroll + (direction * step * slideWidth);
        if (direction === 1 && newPosition > maxScroll) newPosition = 0;
        else if (direction === -1 && newPosition < 0) newPosition = maxScroll;
        this.slider.scrollTo({ left: newPosition, behavior: 'smooth' });
      }

      this.wasClicked = true;
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    // Original logic for non-infinite scroll
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);
    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  // Attempt initialization until slider items are ready
  tryInitInfiniteScroll(retries = 10, delay = 100) {
    if (!this.enableInfiniteScroll) return;

    // Ensure slider measurements exist
    if (!this.sliderItemsToShow || this.sliderItemsToShow.length < 2 || !this.sliderItemOffset) {
      if (retries <= 0) return;
      setTimeout(() => this.tryInitInfiniteScroll(retries - 1, delay), delay);
      return;
    }

    this.initInfiniteScroll();
  }

  initInfiniteScroll() {
    if (this.infiniteScrollInitialized) return;

    // Use the slider element container that holds slides
    const sliderList = this.slider.querySelector('.product__media-list') || this.slider;

    // Save originals
    this.originalSlides = Array.from(this.sliderItemsToShow);
    this.slidesToClone = Math.min(2, this.originalSlides.length);

    // Prepend clones of last slides (reverse order so the immediate-left clone matches the last real slide)
    for (let i = this.originalSlides.length - 1; i >= this.originalSlides.length - this.slidesToClone; i--) {
      const source = this.originalSlides[i];
      const clone = source.cloneNode(true);
      this.prepareCloneMedia(clone, source);
      clone.classList.add('slide-clone', 'slide-clone-before');
      sliderList.prepend(clone);
    }

    // Append clones of first slides
    for (let i = 0; i < this.slidesToClone; i++) {
      const source = this.originalSlides[i];
      const clone = source.cloneNode(true);
      this.prepareCloneMedia(clone, source);
      clone.classList.add('slide-clone', 'slide-clone-after');
      sliderList.appendChild(clone);
    }

    // Refresh references and recalc offsets
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((el) => el.clientWidth > 0);
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

    // Position at first real slide (after prepended clones)
    const initialPosition = this.slidesToClone * this.sliderItemOffset;
    this.slider.scrollTo({ left: initialPosition, behavior: 'auto' });
    this.currentPage = this.slidesToClone + 1;

    // Add scrollend fallback
    if ('onscrollend' in window) {
      this.slider.addEventListener('scrollend', this.checkInfiniteScroll.bind(this));
    } else {
      let scrollTimer;
      this.slider.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => this.checkInfiniteScroll(), 150);
      });
    }

    this.infiniteScrollInitialized = true;
  }

  // Ensure cloned media are already loaded/decoded to avoid visual refresh/fade
  prepareCloneMedia(cloneSlide, sourceSlide) {
    try {
      const sourceImgs = sourceSlide ? Array.from(sourceSlide.querySelectorAll('img')) : [];
      const cloneImgs = Array.from(cloneSlide.querySelectorAll('img'));
      cloneImgs.forEach((imgClone, idx) => {
        const imgSrc = sourceImgs[idx] || sourceImgs[0];
        if (imgSrc) {
          if (imgSrc.currentSrc) imgClone.src = imgSrc.currentSrc;
          else if (imgSrc.src) imgClone.src = imgSrc.src;
          if (imgSrc.srcset) imgClone.srcset = imgSrc.srcset;
          if (imgSrc.sizes) imgClone.sizes = imgSrc.sizes;
          // Copy loaded-state classes if present (common in lazyload setups)
          ['lazyloaded', 'loaded', 'image-loaded'].forEach((cls) => {
            if (imgSrc.classList && imgSrc.classList.contains(cls)) imgClone.classList.add(cls);
          });
        }
        if (imgClone.getAttribute('loading') === 'lazy') imgClone.setAttribute('loading', 'eager');
        imgClone.setAttribute('decoding', 'async');
        if (typeof imgClone.decode === 'function') {
          imgClone.decode().catch(() => {});
        }
      });

      const cloneVideos = Array.from(cloneSlide.querySelectorAll('video'));
      cloneVideos.forEach((v) => {
        try {
          v.setAttribute('preload', 'auto');
        } catch (_) {}
      });
    } catch (_) {
      // Best-effort; ignore errors
    }
  }

  checkInfiniteScroll() {
    if (!this.infiniteScrollInitialized) return;

    const scrollLeft = this.slider.scrollLeft;
    const slideWidth = this.sliderItemOffset;
    const realCount = this.originalSlides ? this.originalSlides.length : 0;

    // Prefer center-based index detection, fallback to width-based rounding
    let index = Number.isFinite(this.getIndexFromScroll(scrollLeft))
      ? this.getIndexFromScroll(scrollLeft)
      : Math.round(scrollLeft / (slideWidth || 1));

    const debug = this.getAttribute('data-debug-infinite') === 'true';
    if (debug) console.debug('checkInfiniteScroll', { index, slideWidth, slidesToClone: this.slidesToClone, realCount });

    // Make sure our data is consistent before attempting repositioning
    if (!this.originalSlides || !this.slidesToClone || !this.sliderItemsToShow || this.sliderItemsToShow.length < 1) {
      if (debug) console.debug('checkInfiniteScroll: not ready', { index, slideWidth, slidesToClone: this.slidesToClone, realCount, sliderItemsToShowLength: this.sliderItemsToShow ? this.sliderItemsToShow.length : 0 });
      return;
    }

    // If we are on clones at the end (after original slides)
    if (index >= this.slidesToClone + realCount) {
      const target = index - realCount;
      const safeIndex = Math.min(Math.max(0, target), this.sliderItemsToShow.length - 1);
      const newPosition = this.sliderItemsToShow[safeIndex] ? this.sliderItemsToShow[safeIndex].offsetLeft : target * slideWidth;
      if (Math.abs(newPosition - scrollLeft) > 1) this.repositionToPosition(newPosition);
      return;
    }

    // If we are on clones at the beginning
    if (index < this.slidesToClone) {
      const target = realCount + index;
      const safeIndex = Math.min(Math.max(0, target), this.sliderItemsToShow.length - 1);
      const newPosition = this.sliderItemsToShow[safeIndex] ? this.sliderItemsToShow[safeIndex].offsetLeft : target * slideWidth;
      if (Math.abs(newPosition - scrollLeft) > 1) this.repositionToPosition(newPosition);
      return;
    }
  }

  repositionToPosition(newPosition) {
    if (this.isRepositioning) return;
    this.isRepositioning = true;
    // Suppress UI updates during the silent jump to avoid flicker
    this.suppressUpdateUntilReposition = true;
    const originalBehavior = this.slider.style.scrollBehavior;
    this.slider.style.scrollBehavior = 'auto';
    this.slider.scrollLeft = newPosition;
    // small timeout to allow layout, then restore behavior and re-enable updates
    setTimeout(() => {
      this.slider.style.scrollBehavior = originalBehavior || '';
      this.isRepositioning = false;
      setTimeout(() => {
        this.suppressUpdateUntilReposition = false;
      }, 10);
    }, 20);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });

    // error prevention
    if(this.sliderControlButtons[this.currentPage - 1]) {
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  /**
   * Sets the visibility of the slider items based on the current page.
   * It also manages the tabindex and aria attributes for accessibility.
   *
   * @param {Event} event - The event object.
   */
  setSlideVisibility(event) {
    if (this.isRepositioning) return; // Skip during repositioning to avoid conflicts

    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      let isVisible = false;

      if (this.enableInfiniteScroll && this.infiniteScrollInitialized) {
        // For infinite scroll, determine visibility based on whether this is the current "real" slide
        const realIndex = this.getRealSlideIndex(index);
        const currentRealIndex = this.getRealSlideIndex(this.currentPage - 1);
        isVisible = realIndex === currentRealIndex;
      } else {
        isVisible = index === this.currentPage - 1;
      }

      if (isVisible) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    
    this.wasClicked = false;
  }

  // Helper method to get the real slide index (accounting for clones)
  getRealSlideIndex(index) {
    if (!this.enableInfiniteScroll || !this.infiniteScrollInitialized) return index;
    
    const totalSlides = this.sliderItemsToShow.length;
    const realSlidesCount = this.originalSlides.length;
    
    // If it's a cloned slide at the beginning
    if (index < this.slidesToClone) {
      return realSlidesCount - this.slidesToClone + index;
    }
    // If it's a cloned slide at the end
    else if (index >= this.slidesToClone + realSlidesCount) {
      return index - this.slidesToClone - realSlidesCount;
    }
    // It's a real slide
    else {
      return index - this.slidesToClone;
    }
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    
    let targetSlideIndex = this.sliderControlLinksArray.indexOf(event.currentTarget);
    
    if (this.enableInfiniteScroll && this.infiniteScrollInitialized) {
      // For infinite scroll, calculate the position relative to the cloned slides
      targetSlideIndex = targetSlideIndex + this.slidesToClone;
      const slideScrollPosition = targetSlideIndex * this.sliderFirstItemNode.clientWidth;
      this.slider.scrollTo({
        left: slideScrollPosition,
      });
    } else {
      const slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth *
          (targetSlideIndex + 1 - this.currentPage);
      this.slider.scrollTo({
        left: slideScrollPosition,
      });
    }
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;

          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.swiper-slide')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


class DrawerOpener extends HTMLElement {
  constructor() {
      super();

      const button = this.querySelector('button');

      this.drawer = document.querySelector(this.getAttribute('data-drawer'));

      if (!button) return;
      button.addEventListener('click', () => {
          if(button.hasAttribute('aria-disabled') == true) return this.drawer.close()
          if(this.drawer) return this.drawer.open();
      });
  }
}
customElements.define( 'drawer-opener', DrawerOpener)

class DrawerContent extends HTMLElement {
  constructor() {
      super();
      this.querySelector('#drawer__overlay').addEventListener('click', this.close.bind(this));
  }

  open() {
      this.classList.add('active')
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(this, focusElement);

      document.body.classList.add('overflow-hidden');
  }

  close() {
      // opener.removeAttribute('aria-disabled');
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
  }
}
customElements.define('drawer-content', DrawerContent);